/** Governance copy for AI-derived product outputs. */
export const AI_ASSISTED_LABEL = "AI-assisted";

export const AI_ASSISTED_DISCLAIMER_BY_CONTEXT = {
  readiness: "not a final investment readiness assessment",
  diagnostic: "not a final category assessment",
  investment: "not a final investment decision",
  fundraising: "not a final investor recommendation",
  summary: "for informational purposes only",
} as const;

export type TAiAssistedDisclaimerContext = keyof typeof AI_ASSISTED_DISCLAIMER_BY_CONTEXT;

export function formatAiAssistedDisclaimer(context: TAiAssistedDisclaimerContext): string {
  return `${AI_ASSISTED_LABEL} — ${AI_ASSISTED_DISCLAIMER_BY_CONTEXT[context]}`;
}
